// vue-i18n 인스턴스 — 브라우저 언어 자동 감지 (ko / vn / en / ru / th / es)
//   - localStorage 'locale' override 우선 (미래 수동 스위처 도입 대비)
//   - navigator.language 가 ko* → 'ko', vi* → 'vn', th* → 'th', ru* → 'ru', es* → 'es', 그 외 → 'en'
//   - fallbackLocale: 'en' (누락 키는 영어로)
//   - legacy: false → Composition API 호환, globalInjection: true → this.$t() 도 동작
import { createI18n } from 'vue-i18n'
import ko from '@/locales/ko.json'
import en from '@/locales/en.json'
import vn from '@/locales/vn.json'
import ru from '@/locales/ru.json'
import th from '@/locales/th.json'
import es from '@/locales/es.json'

const SUPPORTED = ['ko', 'en', 'vn', 'ru', 'th', 'es']

export function detectLocale() {
  // 1) 사용자가 명시적으로 저장한 값 우선
  if (typeof localStorage !== 'undefined') {
    const saved = localStorage.getItem('locale')
    if (saved && SUPPORTED.includes(saved)) return saved
  }
  // 2) 브라우저 언어 — navigator.language 또는 첫번째 navigator.languages
  const raw = (typeof navigator !== 'undefined'
    && (navigator.language || (navigator.languages && navigator.languages[0]))) || ''
  const lower = String(raw).toLowerCase()
  if (lower.startsWith('ko')) return 'ko'
  if (lower.startsWith('vi')) return 'vn'
  if (lower.startsWith('ru')) return 'ru'
  if (lower.startsWith('th')) return 'th'
  if (lower.startsWith('es')) return 'es'
  return 'en'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  messages: { ko, en, vn, ru, th, es },
})

// 초기 로드 시 <html lang> 동기화 — SEO/스크린리더 친화
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.global.locale.value
}

// 외부에서 locale 변경 — 미래 수동 스위처 도입 시 사용 (한 줄 헬퍼)
export function setLocale(loc) {
  if (!SUPPORTED.includes(loc)) return
  i18n.global.locale.value = loc
  if (typeof localStorage !== 'undefined') localStorage.setItem('locale', loc)
  if (typeof document !== 'undefined')     document.documentElement.lang = loc
}

export default i18n
